import { render, staticRenderFns } from "./OrgTipDialog.vue?vue&type=template&id=599889f5"
import script from "./OrgTipDialog.vue?vue&type=script&lang=js"
export * from "./OrgTipDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports